import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    stepLabel:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
  
}));

export default useStyles;